import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en'
import tc from './tc'
import sc from './sc'

Vue.use(VueI18n)

const locale = 'en'

const messages = {
  en: en,
  tc: tc,
  sc: sc
}

const i18n = new VueI18n({
  locale,
  messages
})

export default i18n